import React, {useContext} from "react";
import PropTypes from "prop-types";

import CameraFilterContext from "../../../CameraListing/CameraFilterContext";
import t from "../../../../../lib/translate";
import * as styles from "./filterbutton.module.less";
import {generateClassString as gcs} from "../../../../../lib/helper/generateClassString";

function FilterButton({filterKey, settings = {}, options = []}) {
    const {addFilterOptionAction, removeFilterOptionAction} =
        useContext(CameraFilterContext);

    const {labelTranslation, type} = settings;
    if (!options.length) return null;

    return (
        <div className={styles.filterButtonWrap}>
            <span>{`${labelTranslation ? t(labelTranslation) : filterKey}`}</span>
            <div className={styles.buttons}>
                {options.map(
                    ({value, label, active = false, disabled = false}) => (
                        <button
                            key={value}
                            disabled={!active && disabled}
                            onClick={() =>
                                active || disabled
                                    ? removeFilterOptionAction(filterKey, value)
                                    : addFilterOptionAction(filterKey, value)
                            }
                            className={gcs(type === "thermal" ? styles.thermal : styles.image, [active, styles.active], [disabled, styles.disabled])}
                        >
                            {type === "image" ? (
                                <span>
                                    {`${label}`}
                                </span>
                            ) : (
                                <div>
                                    <span>
                                        {`< ${label * 1000}`}
                                    </span>
                                    <span>
                                         mK
                                    </span>
                                </div>
                            )}
                        </button>
                    )
                )}</div>
        </div>
    );
}

FilterButton.defaultProps = {
    settings: {}
};

FilterButton.propTypes = {
    filterKey: PropTypes.string.isRequired,
    settings: PropTypes.shape({
        labelTranslation: PropTypes.string
    }),
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            active: PropTypes.bool,
            disabled: PropTypes.bool
        })
    )
};

export {FilterButton};
